import { useEffect, useRef, useState } from "react";

export default function CountUp({ value, decimals = 0, duration = 1100, className = "" }: {
  value: number; decimals?: number; duration?: number; className?: string;
}) {
  const [disp, setDisp] = useState(0);
  const raf = useRef<number>();
  useEffect(() => {
    const reduce = window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
    if (reduce) { setDisp(value); return; }
    const t0 = performance.now();
    const tick = (t: number) => {
      const p = Math.min(1, (t - t0) / duration);
      const e = 1 - Math.pow(1 - p, 3);
      setDisp(value * e);
      if (p < 1) raf.current = requestAnimationFrame(tick);
      else setDisp(value);
    };
    raf.current = requestAnimationFrame(tick);
    return () => { if (raf.current) cancelAnimationFrame(raf.current); };
  }, [value, duration]);
  const txt = decimals ? disp.toFixed(decimals).replace(".", ",") : Math.round(disp).toString();
  return <span className={className}>{txt}</span>;
}
